import React from "react";
import "./Button.scss";

const Button = ({
  children,
  onClick,
  type = "button",
  styleType = "primary",
  classNames = "",
  disabled = false,
  ...props
}) => {
  return (
    <button
      type={type}
      className={`common-button ${classNames} ${styleType}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
